module.exports = __webpack_public_path__ + "img/frontier_side.41ea2213.png";